import { isAxiosError } from 'axios';

// An Error's name, message and stack aren't enumerable, so an Error logged
// as-is loses them. They're copied out here alongside the error's own fields,
// such as an Amplify error's underlyingError and metadata, and any error held
// in one of those fields gets the same treatment. An axios error's own fields
// hold the request config, with its Authorization header and body, so only its
// status and code are kept.
export const errorDetails = (error: unknown, depth = 0): unknown => {
  if (!(error instanceof Error)) return error;

  const { name, message, stack } = error;
  if (isAxiosError(error)) {
    return {
      name,
      message,
      stack,
      status: error.response?.status,
      code: error.code,
    };
  }

  const fields =
    depth < 3
      ? Object.fromEntries(
          Object.entries(error).map(([key, value]) => [
            key,
            errorDetails(value, depth + 1),
          ]),
        )
      : {};

  return { ...fields, name, message, stack };
};
